<div id="lesson">
    <div class="container-fluid">
        <div class="row">

            <div class="col-md-3">
                <a routerLink="/research/mou"> <i class="fas fa-long-arrow-alt-left"></i> Go Back</a>
                <nav id="secondary-navigation">
                    <header class="header">
                        <h5>Functional MOUs (2025-26)</h5>
                    </header>

                    <ul>
                        <li class="first"><a (click)="changeRoute('1')">MOU 2025-26</a></li>
                    </ul>
                </nav>
            </div>

            <div class="col-md-9">
                <div class="card shadow-lg">
                    <iframe [src]="src | safe" width="100%" height="1100" allow="autoplay"
                        (load)="hideLoader()"></iframe>
                </div>
            </div>

        </div>
    </div>
</div>